import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'question',
      type: 'input',
      label: '标题',
      placeholder: '请输入标题'
    }
  ]
}
